import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'

import { FeatureFlagsTable } from './table-components/FeatureFlagsTable'
import { CreateFeatureFlagDialog } from './components/CreateFeatureFlagDialog'
import {
  AddFeatureFlagButton
} from "@/pages/super-admin/feature-flags/header-action-components/AddFeatureFlagButton.tsx";

export default function SuperAdminFeatureFlagsPage() {
  const { t } = useTranslation('super-admin-feature-flags')
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}>
        <PageHeaderActions>
          <AddFeatureFlagButton onClick={() => setIsCreateDialogOpen(true)} />
        </PageHeaderActions>
      </PageHeader>

      <FeatureFlagsTable />

      <CreateFeatureFlagDialog
        isOpen={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
      />
    </PageLayout>
  )
}
